import script from "./ProjectChange.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectChange.vue?vue&type=script&setup=true&lang=js"

import "./ProjectChange.vue?vue&type=style&index=0&id=5b66216e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b66216e"]])

export default __exports__